import React, { useState, useEffect, useCallback, Fragment } from 'react';
import {
  FLink,
  Checkbox,
  Button,
  ComboBox,
  Tooltip,
  WideAlert,
  FModal,
  LoadingIndicator,
  Icons,
} from '@components';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { AlteracaoPerfilService } from '@services/alteracao-perfil';
import { format } from 'date-fns';
import {
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiCommentAlertOutline,
} from '@mdi/js';
import { QUESTIONARIO_ABSOLUTE_PATH } from '../../../../common/utils/paths';

export const PerfilInvestimentoAtual = () => {
  const navigate = useNavigate();
  const users = useSelector((state) => state.user);
  const { questionario_investidor: showQuestionario } = useSelector(
    (state) => state.telasDisponiveis
  );

  const [loading, setLoading] = useState(false);
  const [statusRetTroca, setStatusRetTroca] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [perfisInvestimento, setPerfisInvestimento] = useState([]);
  const [perfilAtual, setPerfilAtual] = useState({ Label: '', Value: '' });
  const [perfilAnalise, setPerfilAnalise] = useState();
  const [perfilTroca, setPerfilTroca] = useState('');
  const [dataAnalise, setDataAnalise] = useState('');
  const [primeiraMudanca, setPrimeiraMudanca] = useState(false);
  const [periodoTroca, setPeriodoTroca] = useState(false);
  const [questObrigatorio, setQuestObrigatorio] = useState(false);
  const [termoAceite, setTermoAceite] = useState(false);

  const listaPlanosParticipante = useCallback(async () => {
    const alteracaoPerfilService = new AlteracaoPerfilService();
    const listaPerfis = await alteracaoPerfilService.getListaPerfilParticipante(
      users.matricula,
      users.plano
    );

    if (Array.isArray(listaPerfis)) {
      setPerfisInvestimento(listaPerfis);
    }
  }, [users.matricula, users.plano]);

  const perfisParticipante = useCallback(async () => {
    setLoading(true);
    const alteracaoPerfilService = new AlteracaoPerfilService();
    setPerfilAtual(users.perfil);

    const perfilAnalisado =
      await alteracaoPerfilService.getResultadoQuestionario(
        users.matricula,
        users.token
      );

    setPerfilAnalise(perfilAnalisado.Resultado);
    setDataAnalise(perfilAnalisado.DataCriacao);
    setLoading(false);
  }, [users.matricula, users.perfil, users.token]);

  const recuperaTravas = useCallback(async () => {
    setLoading(true);
    const alteracaoPerfilService = new AlteracaoPerfilService();
    const dispAlterarPerfil =
      await alteracaoPerfilService.getVerificarDisponibilidadeAlterarPerfil(
        users.matricula
      );
    setPrimeiraMudanca(dispAlterarPerfil.travaQuestionario);
    setPeriodoTroca(!dispAlterarPerfil.travaPeriodo);
    setQuestObrigatorio(dispAlterarPerfil.travaQuestinarioExpirado);

    setLoading(false);
  }, [users.matricula]);

  const handleAlterarPlano = async () => {
    setLoading(true);
    const alteracaoPerfilService = new AlteracaoPerfilService();
    const alteracaoPerfil = await alteracaoPerfilService.setPerfilParticipante({
      matricula: users.matricula,
      codigoPerfilVigente: perfilAtual.Value,
      codigoPerfilDesejado: perfilTroca,
    });
    if (alteracaoPerfil.Error === null) {
      setModalIsOpen(true);
    } else {
      setModalIsOpen(true);
      setStatusRetTroca(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    listaPlanosParticipante();
    perfisParticipante();
    recuperaTravas();
  }, [listaPlanosParticipante, perfisParticipante, recuperaTravas]);

  return !loading ? (
    <div className="card">
      <div className="card-body">
        {primeiraMudanca ? (
          <>
            <div className="row">
              <div className="col-12 col-md-8 col-lg-6">
                <h4 className="ts-8 fw-bold text-muted mb-2">
                  Perfil de investimento atual:
                </h4>
                <h1 className="ts-32 fw-bold text-grey mb-3">
                  {perfilAtual.Label}
                </h1>
              </div>
            </div>
            <div className="mt-32">
              <p className="ts-14 text-muted lh-lg">
                Antes de iniciar a alteração do seu perfil de intestimento, a
                Forluz quer saber mais sobre você! Elaboramos um questionário de
                análise de perfil do investidor, que tem como objetivo conhecer
                o melhor seu nível de tolerância a risco, a partir de dados
                referentes ao seu momento de vida para te orientar nesta
                decisão.
                <br />
                <br />
                Este passo, além de indicar o perfil que melhor se adequa às
                suas caracterís cas e necessidades, é uma determinação legal.
                Conforme a instrução PREVIC No 6, de 14 de novembro de 2019, as
                entidades fechadas de previdência complementar que oferecem
                diferentes perfis de investi mento devem prestar informações
                claras acerca dos impactos da escolha e verificar se a opção
                feita pelo parti cipante é a mais recomendada à sua situação.
                Este levantamento deve ser aplicado periodicamente, com prazo
                máximo de 36 meses. Informamos ainda que, caso opte por não
                atualizar estes dados, você será enquadrado automaticamente no
                Perfil Conservador.
              </p>
              <br />
              <br />
              {showQuestionario && (
                <div className="row mb-32 justify-content-center">
                  <div className="col-12 col-md-8 col-lg-6">
                    <Button
                      className=""
                      onClick={() => navigate(QUESTIONARIO_ABSOLUTE_PATH)}
                    >
                      Realizar análise
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <div className="row">
              <div className="col-12 col-md-8 col-lg-6">
                <h4 className="ts-8 fw-bold text-muted mb-2">
                  Perfil de investimento atual:
                </h4>
                <h1 className="ts-32 fw-bold text-grey mb-3">
                  {perfilAtual.Label}
                </h1>
              </div>
              <div className="col-12 col-md-8 col-lg-6">
                <h4 className="ts-8 fw-bold text-muted mb-2">
                  Perfil de investimento analisado:
                  <Tooltip
                    title={`Perfil analisado conforme formulário preenchido no dia ${
                      dataAnalise && format(new Date(dataAnalise), 'dd/MM/yyyy')
                    }`}
                  >
                    ?
                  </Tooltip>
                </h4>
                <h1 className="ts-32 fw-bold text-grey">{perfilAnalise}</h1>
                {showQuestionario && (
                  <FLink
                    className="justify-content-start mb-32"
                    onClick={() => navigate(QUESTIONARIO_ABSOLUTE_PATH)}
                  >
                    Para refazer o questionário clique aqui
                  </FLink>
                )}
              </div>
            </div>
            <p className="ts-20 text-muted fw-bold text-orange">Informativo:</p>
            <ul className="ts-14 ms-0 my-2 ps-4 lh-base text-muted mb-32">
              <li>
                Quaisquer investimentos efetuados no mercado financeiro estão
                expostos a riscos;
              </li>
              <li>
                Os diferentes perfis postos à minha opção têm níveis de riscos
                diversos;
              </li>
              <li>
                A rentabilidade obtida no passado não representa garantia de
                resultados futuros;
              </li>
              <li>
                O Plano não conta com quaisquer garantias para cobertura de
                perdas;
              </li>
              <li>
                A solicitação de alteração do perfil de investimento só poderá
                ser feita nos seguintes meses: fevereiro, maio, agosto e
                novembro.
              </li>
            </ul>
            <hr />
            {periodoTroca && !questObrigatorio && (
              <>
                <div className="d-flex mb-32 mt-32">
                  <Checkbox
                    className="beneficiario_checkbox"
                    defaultChecked={termoAceite}
                    onChange={setTermoAceite}
                    disabledCheckbox={termoAceite}
                  />
                  <p className="text-muted ts-14">
                    Declaro ter recebido da Forluz as informações e
                    esclarecimentos necessários e suficientes para as minhas
                    escolhas, as quais são feitas sob minha inteira
                    responsabilidade, declarando, ainda, estar ciente, sem
                    discordância, dos itens descritos acima.
                  </p>
                </div>
                <div className="row mb-32 mt-32">
                  <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                    <div className="row">
                      <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                        <ComboBox
                          id="perfilInvestimento"
                          options={perfisInvestimento.map((x) => {
                            return { value: x.Key, label: x.Value };
                          })}
                          isDisabled={!termoAceite}
                          value={perfilTroca}
                          onChange={setPerfilTroca}
                          name="perfilInvestimento"
                          label="Alterar perfil de investimento"
                        />
                      </div>
                      <div className="col-12 col-lg-4 mb-3 ">
                        <Button
                          disabled={!termoAceite}
                          className="mt-4"
                          onClick={async () => handleAlterarPlano()}
                        >
                          Alterar
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {questObrigatorio && showQuestionario && (
              <WideAlert className="mb-4" iconClear={false}>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiCommentAlertOutline}
                    color="var(--primary-color)"
                    size={2}
                    style={{ marginRight: 4 }}
                  />
                  <p className="ts-16">
                    <strong>Aviso importante:</strong> Não foi encontrada
                    nenhuma análise de perfil de investimento nos últimos 36
                    meses.
                    <br />
                    Não perca tempo, preencha o questionário de análise de
                    perfil{' '}
                    <Link
                      className="fw-bold text-orange"
                      to={QUESTIONARIO_ABSOLUTE_PATH}
                    >
                      clicando aqui
                    </Link>
                  </p>
                </div>
              </WideAlert>
            )}
            {!periodoTroca && (
              <WideAlert className="mb-4" iconClear={false}>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiCommentAlertOutline}
                    color="var(--primary-color)"
                    size={2}
                    style={{ marginRight: 4 }}
                  />
                  <p className="ts-16">
                    <strong>Aviso importante:</strong> Não é possível solicitar
                    alteração, pois está fora do período de solicitação.
                  </p>
                </div>
              </WideAlert>
            )}
          </div>
        )}
        <FModal
          isOpen={modalIsOpen}
          close
          onClose={() => setModalIsOpen(false)}
        >
          {statusRetTroca ? (
            <>
              <Icons
                path={mdiCheckCircleOutline}
                color="var(--success)"
                size={2}
              />
              <h1 className="ts-20 fw-bold mb-1">Dados atualizados</h1>
              <p className="ts-16">No próximo mês seu perfil será alterado</p>
            </>
          ) : (
            <>
              <Icons
                path={mdiAlertCircleOutline}
                color="var(--error)"
                size={2}
              />
              <h1 className="ts-20 fw-bold mb-1">Ocorreu um erro</h1>
              <p className="ts-16">Entre em contato com a Forluz</p>
            </>
          )}
        </FModal>
      </div>
    </div>
  ) : (
    <LoadingIndicator />
  );
};
